module.exports = __webpack_public_path__ + "media/assets/images/connectors/azure-logo-dccf0886148a259fa16ead84358ae8df.svg";